export default {
  footers: {
    orgname: 'Beijing Increscence Technology Co., Ltd.',
    address: 'S. Zhongguancun St No.48, Haidian, Beijing, PRC',
    email: 'E-mail: product@increscence.net',
  },
  login: {
    login: 'Login',
    iplogin: 'Ip Login',
    userloginservice: 'User Login Service',
    userlog: 'WDL Personal Account Login',
    personalaccount: 'Login',
    accountidorusername: 'Account ID or User Name',
    password: 'Password',
  },
  enroll: {
    lor: 'Personal Account Login/Register',
    user: "Please type in your Personal Account's user name",
    pass: 'Please set your password',
    repass: 'Please verify your password',
    email: 'Please type in your E-mail address',
    reemail: 'Please submit a correct and reachable E-mail address',
    code: 'Verification Code',
    getcode: 'Obtain',
    register: 'Register',
    reset: 'Reset'
  },
  // 头部
  header: {
    lookemail: 'Personal Center',
    Welcome: 'Welcome',
    version: 'Legacy link',
    colleges: "College navigation",
    login: 'Login',
    enroll: 'Enroll',
    out: 'Exit'
  },
  // 检索字段
  option: {
    schoolname: 'school_name',
    topic: 'Topic',
    title: 'Title',
    author: 'Author',
    keyword: 'Keyword',
    chkeyword: 'Chinese Keyword',
    source: 'Source',
    abstract: 'Abstract',
    issueDate: 'Issue Date',
    advisor: 'Advisor',
    language: 'Language',
    degree: 'Degree',
    major: 'Major',
    country: 'Country',
    and: 'AND',
    or: 'OR',
    nor: 'NOR',
    addRule: 'Add Rule',
    delete: 'Delete',
    search: 'Search',
    history: 'History',
    clearHistory: 'Clear History',
    basicSearch: 'Basic Search',
    advancedSearch: 'Advanced Search',
    searchinresults: 'Search in results',
    nohistory: 'There is no recent history',
    inputplaceholder: 'Input Search Keyword…',
    schoolList: 'School List',
    searchHistory: 'Search history',
    range: 'By',
    relation: 'Relation',
    content: 'Term(s)',
    searchCondition: 'Search condition',
    searchResult: 'Search result',
    searchTime: 'Search time',
    oldSwitch: "Switch to Semantic Retrieval",
    newSwitch: "Switch to Traditional Retrieval",
    remarkSwitch: 'You can input a "sentence" or a "paragraph" to search for relevant dissertations on the topic in depth',
    enrollInput: "Please input the topic, abstract, index, or other information of the dissertation you need to search for."
  },
  // 首页信息
  home: {
    introduction: 'Introduction',
    searchdescription: 'Search description',
    introductioninfo: "The New Academic Global Thesis Selection and Integration Service Platform is a platform for selecting high-quality academic doctoral theses. This platform collects dissertations from key universities around the world, with over 90% of the top 100 universities covering major countries and regions worldwide. It covers various disciplines such as basic science, pharmaceutical science, life sciences, biotechnology, engineering technology, social sciences and humanities, and is an essential professional information retrieval tool for scientific research and teaching.",
    searchdescriptioninfo1: '1. To start a searching, please type your search word into the input box, the search word(s) must be in English.',
    searchdescriptioninfo2: '2. Adding a new field also sets the second field to the AND operator. You can change the AND operator to OR or NOT.',
    searchdescriptioninfo3: '3. The default search field is "Title"，you can learn the amount of contents related to your search word.',
    searchdescriptioninfo4: '4. Optional search fields: Topic, Title, Author, Keyword, Source, Abstract, and Issue Date.',
    searchdescriptioninfo5: '5. For a more accurate and detailed search result, please apply the Advanced Search.',
    academytitle: 'Institutes & Universities Selection',
    academyinfo1: 'In order to ensure the academic quality of the collected literature, the New Academic Global Thesis Selection and Integration Service Platform has strict evaluation standards for the source universities of the papers. Collecting dissertations from key universities worldwide, with a coverage rate of over 90% among the top 100 universities globally.',
    academyinfo2: 'The source universities of the papers are distributed across various continents around the world, covering numerous countries such as the United States, Canada, the United Kingdom, Germany, Belgium, France, the Netherlands, Japan, South Korea, Singapore, India, Sweden, the Czech Republic, Switzerland, Austria, Spain, Australia, Norway, Finland, South Africa, and Kenya.',
    subjectfieldtitle: 'Major Disciplines and Amount of Papers',
    subjectfieldinfo: 'As of December 2023, the Newacademic World Dissertation Library has indexed more than 1,407,000 papers in total, including more than 744,000 dissertations of the world’s top 100 institutes with a high academic quality.',
    subjectfieldinfo1: '',
    subjectfieldinfo2: 'Basic & Applied Sciences',
    subjectfieldinfo2_n: '500,000+ papers',
    subjectfieldinfo3: 'Engineering & Technology',
    subjectfieldinfo3_n: '580,000+ papers',
    subjectfieldinfo4: 'Medicine & Life Sciences',
    subjectfieldinfo4_n: '470,000+ papers',
    subjectfieldinfo5: 'Social & Management Sciences',
    subjectfieldinfo5_n: '670,000+ papers',
    subjectfieldinfo6: 'Agricultural Sciences',
    subjectfieldinfo6_n: '130,000+ papers',
    subjectfieldinfo7: 'Arts & Humanities',
    subjectfieldinfo7_n: '116,000+ papers',
    subjectfieldinfo8: 'Miscellaneous',
    subjectfieldinfo8_n: '450,000+ papers',
  },
  // 高级检索说明
  advanceinfo: {
    advanceinfotitle: 'Advanced search instructions:',
    advanceinfo1: '1、Each input box supports English phrases by default, and Chinese search words are not supported;',
    advanceinfo2: '2、Optional search items: title, author, subject, school, keywords, abstract, publication date, language and country, etc;',
    advanceinfo3: '3、Advanced retrieval supports multiple retrieval items to be retrieved at the same time. The logical relationship of "and, or, nor" can be set among the retrieval items, with high precision.',
  },
  // 检索页信息
  search: {
    schoolname: 'School',
    results: 'results',
    opengraph: 'Open the graph summary',
    closegraph: 'Close the graphic summary',
    orderby: 'Order By',
    relevance: 'Relevance',
    dateNewest: 'Date Newest',
    dateOldest: 'Date Oldest',
    title: 'Title',
    author: 'Author',
    details: 'Details',
    abstract: 'Abstract',
    showMore: 'Show More',
    startYear: 'StartYear',
    endYear: 'EndYear',
    publishYear: 'PublishYear',
    degree: 'Degree',
    language: 'Language',
    major: 'Major',
    tutor: 'Tutor',
    clear: 'Clear',
    country: 'Country',
    refinemyresults: 'Refine my results',
    filter: 'Filter',
    exclude: 'Exclude',
    count: 'Count',
    search: 'Search for college papers',
    univOverview: 'View college details',
    showMore: 'Show more',
    showup: "Show less",
    eachPageShows: 'Each page shows',
    page: '/page',
    displayMode: 'Display mode',
    detail: 'Detail',
    list: 'List',
    packUp: 'Pack up',
    academy: 'Academy',
    operation: 'Operation',
    abstractfanyi: "Abstract translation",
    translation: 'Translation',
    original: "Original",
    open: 'Show more',
    close: 'Show less',
    searchswitchct: 'Switch traditional retrieval',
    searchswitchyy: 'Switch semantic retrieval',
    searchplaceholder: 'The search content can be keywords, phrases, titles, or paragraphs',
    year: 'Year',
    zhi: 'To',
    years: 'Years',
    degree: 'Degree',
    language: 'Language',
    Sourceinstitution: 'Source institution',
    loadingText: "loading...",
    noData: 'No data'
  },
  // 详情页
  detail: {
    // 详情页--论文详情
    thesisinfo: 'THESIS INFO',
    univOverview: 'UNIV OVERVIEW',
    univRankings: 'UNIV RANKINGS',
    subjects: 'SUBJECTS',
    within: 'Within current University',
    entire: 'Entire site',
    home: 'Home',
    abstract: 'Abstract',
    affiliations: 'Affiliations',
    keywords: 'Keywords',
    graphicalAbstract: 'Graphical Abstract',
    citethispaper: 'Cite this paper',
    fullText: 'Full Text',
    translate: 'Translate',
    translatetitle: 'Translate the title',
    offtranslation: 'Turn off translation',
    sameAdvisorTheses: 'Same Advisor Theses',
    relatedTheses: 'Related Theses',
    hotTheses: 'Hot Theses',
    original: 'Original',
    translation: 'Translation',
    chinese: 'Chinese (Simplified)',
    thai: 'Thai',
    english: 'English',
    german: 'German',
    french: 'French',
    spanish: 'Spanish',
    japanese: 'Japanese',
    portuguese: 'Portuguese',
    italian: 'Italian',

    // 详情页--院校排名
    globalRank: 'Global Rank',
    regionalRank: 'Regional Rank',
    countryRank: 'Country Rank',
    totalStudents: 'Total Students',
    universityHighlights: 'UNIVERSITY HIGHLIGHTS',
    internationalstudents: 'International students',
    totalfacultystaff: 'Total faculty staff',
    studentgendermix: 'Student gender mix',
    pgstudents: 'PG students',
    ugstudents: 'UG students',
    internationalstaff: 'International staff',
    domesticstaff: 'Domestic staff',
    men: 'Men',
    women: 'Women',
    iNDICATORRANKINGS: 'INDICATOR RANKINGS',
    similarUniversities: 'SIMILAR  UNIVERSIRIES',
    chart: 'Chart',
    data: 'Data',
    indicatorShow: 'Indicators show',


    // 详情页--学位与研究领域
    dEGREELEVELS: 'DEGREE LEVELS & STUDY AREAS',
    undergraduate: 'Undergraduate',
    postgraduate: 'Postgraduate',
    preBachelordegrees: 'PreBachelor degrees',
    bachelordegrees: 'Bachelor degrees',
    masterdegrees: 'Master degrees',
    doctoraldegrees: 'Doctoral degrees',
    artsHumanities: 'Arts & Humanities',
    businessSocialSciences: 'Business & Social Sciences',
    languageCultural: 'Language & Cultural',
    medicineHealth: 'Medicine & Health',
    engineering: 'Engineering',
    scienceTechnology: 'Science & Technology',

    CreationTime: "Creation Time",
    address: "Address",
    url: "URL",
    SubjectRankings: 'Subject Rankings',
    subject: 'Subject',
    ranking: "Ranking",
    KeyStatistics: "Key Statistics",
    FeaturedDisciplines: 'Featured Disciplines',
    AllDisciplines: 'All Disciplines',
    region: 'Region',
    yy: 'Cite this paper'
  },
  // 底部栏
  footer: {
    info: 'The recommended screen resolution setting is no less than 1024x768. For optimal visiting experience of this site, you should use browsers that support HTML-5.(Such as the latest version of Google Chrome, Firefox, and Edge)'
  },
  // 学校列表页
  schoollist: {
    sort: 'Sort by first name',
    backtotop: 'Back to top',
  },
  //语言
  language: {
    Arabic: "Arabic",
    German: "German",
    Russian: "Russian",
    French: "French",
    Korean: "Korean",
    Portuguese: "Portuguese",
    Japanese: "Japanese",
    Thai: "Thai",
    Spanish: "Spanish",
    English: "English",
    Italian: "Italian",
    Vietnamese: "Vietnamese",
    Chinese: "Simplified Chinese",
    error: 'Translation failed',
    Indonesian: "Indonesian",
    close: 'Close translation'
  },
  language_: {
    Arabic: "بالعربية",
    German: "Deutsch",
    Russian: "Русский язык",
    French: "Français",
    Korean: "한국어",
    Portuguese: "Português",
    Japanese: "日本語",
    Thai: "ภาษาไทย",
    Spanish: "Español",
    English: "English",
    Italian: "Italiano",
    Vietnamese: "Tiếng Việt",
    Chinese: "简体中文",
    error: 'Translation failed',
    Indonesian: "Bahasa Indonesia",
    close: 'Close translation'
  },
  // 个人中心
  user: {
    PersonalCenter: 'Personal Center',
    user: 'User',
    email: 'Email',
    mechanism: 'Mechanism',
    Expirationtime: 'Expiration time',
    Searchrecord: 'Search record',
    Transferrecord: 'Transfer record',
    Searchterm: 'Search term',
    condition: 'Condition',
    request: 'Request IP',
    Retrievaltime: 'Retrieval time',
    operation: 'Operation',
    title: 'Title',
    Transferemail: 'Transfer email',
    Transfertime: 'Transfer time'
  }
}



// WEBPACK FOOTER //
// ./src/assets/lang/en.js